<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

        <!--
        <pre>
            {{ topic }}
        </pre>
        -->


		<!-- page-heading -->
		<page-heading :show="true" :pageTitle="title"></page-heading>

		<div class="columns">

			<div class="col-main">

                <div class="box">

                    <form-input inputType="text" label="CPT-TOPIC_NAME" inputSize="is-medium" v-model="topic.name" :isHorizontal="true"></form-input>

                    <div class="control is-horizontal">

                        <div class="control-label">
                            <label-name labelKey="CPT-TOPIC-DATE_BEGIN"></label-name>
                        </div>

                        <div class="control">
                            <datepicker placeholder="Datum wählen" :options="datePickerOptions" disabled v-model="topic.startDate"></datepicker>
                        </div>

                    </div>

                    <div class="control is-horizontal">

                        <div class="control-label">
                            <label-name labelKey="CPT-TOPIC-DATE_END"></label-name>
                        </div>

                        <div class="control">
                            <datepicker placeholder="Datum wählen" :options="datePickerOptions" disabled v-model="topic.endDate"></datepicker>
                        </div>

                    </div>


                    <form-input inputType="text" label="CPT-TOPIC_COLOR" inputSize="is-medium" v-model="topic.color" :isHorizontal="true"></form-input>


                </div>

			</div>

	        <div class="col-aside">

				<affix :offset="50">

		            <div class="sidebox">
						<custom-button type="blue" icon="icon-ak-speichern" name="CPT-BTN-SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>
					</div>

				</affix>

	        </div>

	    </div>

	</template>

</div>
</template>



<script>
import { de } from 'flatpickr/dist/l10n/de';

export default {

    name: 'contentPoolTopic',

	components: {

	},

	data() {

		return {
			topic: null,
			isNewTopic: false,
			isSaving: false,
			isLoading: false,

            datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd. F Y',
                locale: de,
				clickOpens: true
            },

		}
	},


	created() {

		// existing topic - fetch the ID from router
		if(this.$route.params.topicID && Number.isInteger(parseInt(this.$route.params.topicID)) ) {

			this.fetchData();

		}

		// new topic
		else {

			this.isNewTopic = true;

			// create new equipment obj with default values
			this.topic = {
			    name: "",
                startDate: "",
                endDate: "",
                color: ""
			}

		}

	},

    computed: {

        title() {

            if(this.isNewTopic == true) {
                return 'CPT-HEADER-NEW_TOPIC';
            } else {
                return this.topic.name;
            }
        },
    },

	mounted() {

	},


	update() {

	},


	methods: {


		fetchData() {

			this.isLoading = true;
			var self = this;

            this.axios.get(self.$config.api + 'articleTopic/' + this.$route.params.topicID)
				.then(function(response) {

                    self.topic = response.data;
                    self.isLoading = false;

				}).catch(function(error) {
                    self.isLoading = false;
					console.log('Error: ', error.message);
				});

		},


		submitForm() {


            if(this.topic.name == "" || this.topic.startDate == "" || this.topic.endDate == "") {
                this.$notify.open( { content: 'Bitte füllen Sie die Felder "Bezeichnung", "Datum Beginn" und "Datum Ende" aus!', placement: 'center', type: 'warning' });
                return false;
            }

            var d1 = new Date(this.topic.startDate);
            var d2 = new Date(this.topic.endDate);

            if(d1.getTime() >= d2.getTime()) {
                this.$notify.open( { content: 'Das Enddatum muss größer als das Startdatum sein!', placement: 'center', type: 'warning' });
                return false;
            }

			this.entityCreateOrUpdate('articleTopic', this.topic, { msg: 'CPT-MSG-SUCCESSFULLY_SAVED' })
				.then(function(response) {

				});

		}

	}

}

</script>


<style>

</style>
